var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{staticClass:"form-control",attrs:{"value":_vm.value,"config":_vm.datePickerConfig,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }